import styles from "./PageEdit.module.css"
import TextareaAutosize from 'react-textarea-autosize';
/**
 * A reusable text input component for updating form fields.
 *
 * This component abstracts the `<input>` field so it can be reused in multiple places.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.label - The label text for the input.
 * @param {string} props.value - The current value of the input field.
 * @param {Function} props.onChange - Function to handle value changes.
 *
 * @example
 * // Example usage inside a component:
 * <TextInput
 *   label="Title"
 *   value={formData.title}
 *   onChange={(e) => setFormData({ ...formData, title: e.target.value })}
 * />
 */

export default function TextInput({ label, value, onChange }) {
    return (
        <div className={styles.textInput}>
            <label>{label}</label>
            <TextareaAutosize
                value={value}
                onChange={onChange}
                style={{ resize: "None", overflow: 'hidden', width: "100%"}}
                rows={1}
            />
        </div>
    );
}